import { z } from 'zod';

export const PositionOrderCreatedEventSchema = z.strictObject({
    orderId: z.string().uuid(),
    positionId: z.string().uuid(),
});

export type PositionOrderCreatedEventPayload = z.infer<typeof PositionOrderCreatedEventSchema>;
